import { IconButton, Paper, Typography } from '@material-ui/core'
import {
  Headset,
  MessagesSquare,
  Plus
} from 'lucide-react'
import { useStyles } from './style'

const BottomNavbar = ({
  currentTab,
  onTabChange,
  onNewTicket,
  onOpenInternalChat,
  isChatOpen,
}) => {
  const classes = useStyles()

  return (
    <Paper className={classes.root} elevation={3}>
      <div
        className={`${classes.navItem} ${!isChatOpen ? 'active' : ''}`}
        onClick={() => {
          onOpenInternalChat(false) // Garante que fecha o chat ao clicar aqui
          onTabChange('open') // Define a aba de tickets
        }}
      >
        <Headset className={classes.icon} />
        <Typography className={classes.label}>Atendimentos</Typography>
      </div>

      {/* BOTÃO CENTRAL (+) */}
      <div className={classes.centerButtonContainer}>
        <IconButton className={classes.fabButton} onClick={onNewTicket}>
          <Plus size={32} strokeWidth={3} />
        </IconButton>
      </div>

      <div
        className={`${classes.navItem} ${isChatOpen || currentTab === 'internalChat' ? 'active' : ''}`}
        onClick={() => onOpenInternalChat(true)}
      >
        <MessagesSquare className={classes.icon} />
        <Typography className={classes.label}>Chat Interno</Typography>
      </div>
    </Paper>
  )
}

export default BottomNavbar
